<template>
  <div>
    <!-- testimonial Section start-->
    <section id="testimonial" class="testimonial" >
      <div class="container">
        <div class="row">
          <div class="col-lg-8 mx-auto">
            <h2> In the News </h2>
            <p class="lead"> See what people are saying </p>
            <div class="press-row row">
              <div class="col-sm press-article">
                  <a href="https://developer.amazon.com/blogs/alexa/post/1c5f9c52-9222-4669-81be-c091c9c9c151/gal-shenar-has-cracked-the-code-when-it-comes-to-earning-alexa-developer-rewards">
                    <img src="https://stokedskills.com/images/press/amazon.jpg" />
                  </a>
              </div>
              <div class="col-sm press-article">
                  <a href="https://www.cnet.com/news/how-close-is-alexas-escape-the-room-to-an-actual-escape-room/">
                    <span class="cnet-link"> CNET </span> 
                  </a>
                </div>
              <div class="col-sm press-article">
                  <a href="https://www.dashbot.io/2018/06/06/how-this-alexa-skill-developer-increased-retention-of-voice-game-by-15/">
                    <img src="https://stokedskills.com/images/press/dashbot.png" />
                  </a>
              </div>
              <div class="col-sm press-article">
                  <a href="https://www.homeandsmart.de/alexa-skill-dschungelgeraeusche">
                    <img src="https://stokedskills.com/images/press/homesmart.jpg" />
                  </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  name:'Testimonial'
}
</script>



// WEBPACK FOOTER //
// src/components/testimonial.vue